import { ERROR_CODES } from '../models';
import moment from 'moment';

export const ERROR_MSG = 'Oops, an error occured! Please try again later.';
export const BAD_REQUEST = 'Oops, bad request! Please try again with valid response.';
export const UNPROCESSABLE_ENTITY = 'Oops, unprocessable entity! Server unable to process this request.';
export const EMPTY_ROW_MSG = 'No records to display';
export const UNKNOWN_IDENTIFIER_EMPTY_ROW_MSG = 'Currently, there is no data. Please check the following settings on Korona.';
export const ERROR_404 = 'Data not Found!';
export const ERROR_500 = 'Server Error! Please try again later.';
export const ERROR_409 = 'Data conflicts!'
export const NO_PERMISSIONS_ERROR_MSG = `Permission Denied!\nThis action could not be performed.\nError Code: ${ERROR_CODES.NO_PERMISSIONS}`;
export const getCustomPermissionErrorMsg = (actionText: string) =>
  `Permission Denied!\n${actionText}\nError Code: ${ERROR_CODES.NO_PERMISSIONS}`;

export const API_RESPONSE = {
  ADD_INVENTORY_COUNT_SUCCESS: 'Inventory Count created successfully!',
  ADD_INVENTORY_COUNT_FAILURE: 'Failed to create Inventory Count.',
  ADD_INVENTORY_COUNT_LIST_SUCCESS: 'Inventory Count List created successfully!',
  ADD_INVENTORY_COUNT_LIST_FAILURE: 'Failed to create Inventory Count List.',
  UPDATE_INVENTORY_COUNT_LIST_SUCCESS: 'Inventory Count List updated successfully!',
  UPDATE_INVENTORY_COUNT_LIST_FAILURE: 'Failed to update Inventory Count List.',
  DELETE_INVENTORY_COUNT_ITEM_SUCCESS: 'Item deleted successfully!',
  DELETE_INVENTORY_COUNT_ITEM_FAILURE: 'Failed to delete Inventory Count Item.',
  SAVE_LABELER_SETTINGS_FAILURE: 'Error! Failed to save selected location.',
  SAVE_SELECTED_LOCATION_FAILURE: 'Error! Failed to save labeler settings.',
  SAVE_SELECTED_TEMPLATE_FAILURE: 'Error! Failed to save selected template.',
  UPDATE_MASTER_PRODUCT_SUCCESS: 'Master Product updated successfully!',
  UPDATE_MASTER_PRODUCT_FAILURE: 'Failed to update Master Product.',
  GET_MASTER_PRODUCT_DETAIL_FAILURE: 'Failed to retrieve master product info.',
  SEARCH_PRODUCT_BY_CODE_FAILURE: 'Failed to search Product Info.',
  SEARCH_PRODUCT_NOT_FOUND: 'Product not Found!',
  LABEL_PREVIEW_FAILURE: 'Failed To Load Template Preview.',
  UPDATE_UNKNOWN_IDENTIFIER_SUCCESS: 'Unknown Identifier updated successfully!',
  UPDATE_UNKNOWN_IDENTIFIER_FAILURE: 'Unknown Identifier updated successfully!',
  ADD_STOCK_RECEIPT_SUCCESS: 'Stock Receipt created successfully!',
  ADD_STOCK_RECEIPT_FAILURE: 'Failed to create Stock Receipt.',
  UPDATE_STOCK_RECEIPT_SUCCESS: 'Stock Receipt updated successfully!',
  UPDATE_STOCK_RECEIPT_FAILURE: 'Failed to update Stock Receipt.',
  UPDATE_CUSTOMER_ORDER_SUCCESS: 'Customer Order updated successfully!',
  UPDATE_CUSTOMER_ORDER_FAILURE: 'Failed to update Customer Order',
  ADD_STOCK_ORDER_SUCCESS: 'Stock Order created successfully!',
  ADD_STOCK_ORDER_FAILURE: 'Failed to create Stock Order.',
};

export const getErrorMsg = (error: any, defaultMsg: string): string => {
  let msg = defaultMsg;
  if (error && error.status) {
    switch (error.status) {
      case 400:
        msg = BAD_REQUEST;
      case 400:
        msg = UNPROCESSABLE_ENTITY;
      case 401:
        msg = NO_PERMISSIONS_ERROR_MSG;
        break;
      case 403:
        msg = NO_PERMISSIONS_ERROR_MSG;
        break;
      case 404:
        msg = ERROR_404;
        break;
      case 500:
        msg = ERROR_500;
        break;
      default:
        msg = defaultMsg;
    }
  }
  return msg;
};

export const formatDate = (date: string): string => {
  if (date) {
    return moment(date).format('LLL');
  }
  return '';
};

export const formatDate2 = (date: string): string => {
  if (date) {
    return moment(date).format('MM/DD/YY H:mm:ss');
  }
  return '';
};

const DEFAULT_UTC_DATETIME_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';

/**
 * Format a UTC datetime string in a location/business IANA timezone.
 * Falls back to device local time when timezone is missing or unsupported.
 */
export const formatUtcDateTimeInTimezone = (
  utcDate: string | null | undefined,
  timezone?: string | null,
  displayFormat: string = DEFAULT_UTC_DATETIME_DISPLAY_FORMAT,
): string => {
  if (!utcDate) {
    return '';
  }
  const utcMoment = moment.utc(utcDate);
  if (!utcMoment.isValid()) {
    return '';
  }

  if (!timezone) {
    return utcMoment.local().format(displayFormat);
  }

  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(utcMoment.toDate());

    const partValue = (type: string): string =>
      parts.find((part) => part.type === type)?.value ?? '';

    const year = partValue('year');
    const month = partValue('month');
    const day = partValue('day');
    const hour = partValue('hour');
    const minute = partValue('minute');

    if (!year || !month || !day || !hour || !minute) {
      return utcMoment.local().format(displayFormat);
    }

    // Intl may emit "24" for midnight on some engines; normalize to 00.
    const normalizedHour = hour === '24' ? '00' : hour;
    return `${year}-${month}-${day} ${normalizedHour}:${minute}`;
  } catch {
    return utcMoment.local().format(displayFormat);
  }
};
